module.exports = __webpack_public_path__ + "img/pdfestados_pages-to-jpg-rechazada.66475b04.jpg";